const MONTHS = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec']

// "Oct 2022" -> 2022.75, "Present" -> today, "Estimated 2026" -> mid 2026
const toYear = (text: string, isEnd: boolean) => {
  if (/present/i.test(text)) {
    const now = new Date()
    return now.getFullYear() + now.getMonth() / 12
  }
  const m = text.match(/([A-Za-z]{3})?[a-z]*\s*(\d{4})/)
  if (!m) return NaN
  const month = m[1] ? MONTHS.indexOf(m[1].toLowerCase()) : -1
  return Number(m[2]) + (month >= 0 ? month : isEnd ? 6 : 0) / 12
}

// "Oct 2020 - Sep 2022" -> { start: 2020.75, end: 2022.67 } (years as decimals)
export const parsePeriod = (period: string) => {
  const [a, b] = period.split(' - ')
  return { start: toYear(a ?? '', false), end: toYear(b ?? a ?? '', true) }
}

// Companies referenced by the "at" field of each skill in cv-data.json.
// "match" finds the matching entry in experiences by company name.
export const companyDefs = [
  { id: 'presight', label: 'Presight', match: /Presight/i },
  { id: 'sieuviet', label: 'Sieu Viet', match: /Sieu Viet/i },
  { id: 'nth', label: 'NTH', match: /NTH/i },
  { id: 'fpt', label: 'FPT', match: /FPT Software/i },
]
